const initialState = {
    isAuthenticated: !!localStorage.getItem('token'),
    user: null,
    token: null,
    status: ''
};
const reducerAuth = (state, action) => {
    switch (action.type) {
        case "LOGIN":
            localStorage.setItem("token", `Bearer ${action.payload.token}`);
            return {
                ...state,
                token: `Bearer ${action.payload.token}`
            };
        case "USER_LOGGED":
            localStorage.setItem("user", JSON.stringify(action.payload.user));
            return {
                ...state,
                isAuthenticated: true,
                user: action.payload.user,
                status: action.payload.status
            }
        case "LOGOUT":
            localStorage.clear();
            return {
                ...state,
                isAuthenticated: false,
                token: null,
                user: null
            };
        default:
            return state;
    }
};

export { reducerAuth, initialState };